import { render, staticRenderFns } from "./pack-req.vue?vue&type=template&id=509c3eea&scoped=true"
import script from "./pack-req.vue?vue&type=script&lang=js"
export * from "./pack-req.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509c3eea",
  null
  
)

export default component.exports